







































































































































































declare var window: any;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from './../../store.vuex';
import { UserProfile } from '../../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import { ResumeWrapper } from '../../models/jobs/resumeWrapper';
import { Resume } from '../../models/jobs/resume';
import { ResumeRecord } from '../../models/jobs/resumerecord';
import { ResumePayload } from '../../models/jobs/resumepayload';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ResumeDetailsAnonApply',
  components: {
    Datepicker,
  },
})
export default class ResumeDetailsAnonApply extends Vue {
  $toastr: any;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private resumePayload: ResumePayload = new ResumePayload();
  private currentResumeName: string = '';
  private currentResume: ResumeRecord = new ResumeRecord();
  private selectedResume: ResumeRecord = new ResumeRecord();
  private selectedResumes: any;
  private errorString: string = '';
  //new variables
  private showUploadText: boolean = false;
  private selectedNewResume: ResumeRecord = new ResumeRecord();
  private supportedFileSize = 0;
  @Prop() showResumeSection;

  get isLoggedIn() {
    console.log('url', this.thisURL);
    return vxm.users.isLoggedIn;
  }

  get SelectedResume(): ResumeRecord {
    return this.selectedResume;
  }

  get thisURL() {
    return window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ];
  }

  resumeSelected(resume) {
    this.selectedResume = resume;
  }

  get ResumeListing(): ResumeWrapper {
    if (this.resumeListing && this.resumeListing.resumes) {
      this.resumeListing.resumes.forEach((element) => {
        if (element.defaultResume) {
          this.selectedResume = element;
        }
      });
    }
    return this.resumeListing;
  }

  selectResume(resume: ResumeRecord) {
    this.selectedResume = resume;
  }

  renameResume(resume: ResumeRecord) {
    if (resume) {
      if (!resume.fileGUID) {
        this.$toastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('resume.label.renameresume'),
        );
      } else {
        this.currentResume = resume;
        this.currentResumeName = resume.name;
        this.$modal.show('rename-resume');
      }
    }
  }

  get allowedResumeFormat() {
    return vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
  }

  cancelRename() {
    this.$modal.hide('rename-resume');
  }

  async selectFromDropbox() {
    return new Promise<string>((resolve, reject) => {
      vxm.users
        .selectFromDropbox([])
        .then((selected) => {
          const file = selected.file;
          if (!!file) {
            this.resumePayload.resumelink = file.link;
            this.$emit('resume-upload-text', this.resumePayload);
            console.log(
              'resumePayload.resumelink: ' + this.resumePayload.resumelink,
            );
          } else {
            resolve(selected.status);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async submitRename() {
    const vm = this;
    this.$modal.hide('rename-resume');
    this.currentResume.name = this.currentResumeName;
    const respPromise: any = vxm.users.renameResume(this.currentResume);
    const listPromise = vxm.jobs.getApplyFlowResumeListing(vxm.users.getToken);
    const [resp, list] = await Promise.all([respPromise, listPromise]);

    if (resp.success) {
      this.$toastr('success', resp.successMessage, this.$t('resume.label.renameresume'));
      const token = vxm.users.getToken;
      vxm.jobs.getApplyFlowResumeListing(token).then(() => {
        this.resumeListing = vxm.jobs.resumeListing;
      });
    } else {
      this.$toastr('error', resp.errorMessage, this.$t('resume.label.renameresume'));
    }
  }

  async deleteResume(resume: ResumeRecord) {
    const vm = this;
    if (resume && resume.defaultResume !== true) {
      if (!resume.fileGUID) {
        this.$toastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_DeleteResume'),
        );
      } else {
        const respPromise = vxm.users.deleteResume(resume);
        const listPromise = vxm.jobs.getApplyFlowResumeListing(
          vxm.users.getToken,
        );
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        if (resp.success) {
          this.$toastr('success', resp.successMessage, this.$t('ResumeDetails_DeleteResume'));
          const token = vxm.users.getToken;
          vxm.jobs.getApplyFlowResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$toastr('error', resp.errorMessage, this.$t('ResumeDetails_DeleteResume'));
        }
      }
    } else {
      this.$toastr(
        'error',
        this.errorString,
        this.$t('ResumeDetails_DefaultResumeDeleteError'),
      );
    }
  }

  async defaultResume(resume: ResumeRecord) {
    const vm = this;
    if (resume) {
      if (!resume.fileGUID) {
        this.$toastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_SetDefaultResume'),
        );
      } else {
        const respPromise = vxm.users.defaultResume(resume);
        const listPromise = vxm.jobs.getApplyFlowResumeListing(
          vxm.users.getToken,
        );
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        console.log(['in default resume', resp, list]);
        if (resp.success) {
          this.$toastr('success', resp.successMessage, this.$t('ResumeDetails_SetDefaultResume'));

          const token = vxm.users.getToken;
          vxm.jobs.getApplyFlowResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$toastr('error', resp.errorMessage, this.$t('ResumeDetails_SetDefaultResume'));
        }
      }
    }
  }

  uploadResume() {
    const vm = this;
    const token = vxm.users.getToken;
    this.resumePayload.accessToken = token;
    this.resumePayload.jobpostingid = -1;
    this.resumePayload.resumelink = '';
    console.log(this.resumePayload);
    if (this.validateFileSize(this.resumePayload.resumefile)) {
      if (this.validateUploadResume(this.resumePayload)) {
        const respPromise = vxm.jobs
          .postProfileResume(this.resumePayload)
          .then((resp) => {
            if (resp.success) {
              this.$toastr(
                'success',
                this.$t('profile.upload.resume.sucess'),
                this.$t('ResumeDetails_UploadResume'),
              );
            } else if (resp.errorMessage) {
              this.$toastr(
                'error',
                resp.errorMessage,
                this.$t('ResumeDetails_UploadResume'),
              );
              
            } else {
              this.$toastr(
                'error',
                this.$t('profile.upload.resume.error'),
                this.$t('ResumeDetails_UploadResume'),
              );
            }
          });
      } else {
        this.$toastr('error', this.$t(this.errorString), this.$t('ResumeDetails_UploadResume'));
      }
    }
    this.resumePayload.resumefile = '';
  }

  validateFileSize(file) {
    console.log('validating file size for file : ', file);
    if (file.size > this.supportedFileSize) {
      this.$toastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return false;
    }
    return true;
  }

  validateUploadResume(resumePayload: ResumePayload): boolean {
    if (!resumePayload.resume.resumename) {
      this.errorString = 'profile.upload.resume.file.required';
      return false;
    }
    if (resumePayload.resume.resumename.length > 250) {
      this.errorString = 'profile.resume.file.name.exceeded';
      return false;
    }

    return true;
  }
  validateFileFormate() {
    const vm = this;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    if (vm.resumePayload.resumefile) {
      this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
      // if (this.resumePayload.resume.resumename.length > 250) {
      //   this.$toastr(
      //     'error',
      //     'You have exceeded the maximum character limit of 250 characters for file name',
      //     'Upload Resume',
      //   );
      //   return;
      // }
    }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];

    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    // if (!allowedResumeFormat.includes(ext)) {
    //   // this.$toastr(
    //   //   'error',
    //   //   fileNameFormat +
    //   //     ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
    //   //   'Upload Resume',
    //   // );
    //   vm.resumePayload.resumefile = '';
    // }
    if (vm.resumePayload.resumefile.size > this.supportedFileSize) {
      this.$toastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'))
      vm.resumePayload.resumefile = '';
    }

    this.$emit('resume-upload-text', vm.resumePayload);
  }

  mounted() {
    const token = vxm.users.getToken;
    this.showUploadText = false;
    this.supportedFileSize = vxm.utility.fileUploadMaxSize
  }

  //new mthods
  toggleShowUploadText() {
    this.showUploadText = !this.showUploadText;
  }

  get isDropboxEnabled() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('WL_DROPBOX_INTEGRATION_ENABLED')
    ) {
      if (vxm.configs.getGlobalConfigValue('DROPBOX_APP_KEY')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
